var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRariWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.3678V7.90518C4 6.85295 5.02369 6 6.28565 6H10.4409C11.7042 6 12.7278 6.85295 12.7278 7.90518V10.7014C12.7278 11.1837 12.9573 11.6457 13.3658 11.9872C14.218 12.6967 15.5997 12.6967 16.452 11.9872L22.9673 6.55848C23.3959 6.20055 23.9771 6 24.5835 6H25.7143C26.9776 6 28 6.85295 28 7.90518V8.84699C28 9.35216 27.7592 9.83702 27.3306 10.1937L20.8153 15.6237C19.9643 16.3332 19.9643 17.4857 20.8153 18.1952C21.225 18.5366 21.7797 18.7283 22.3584 18.7283H25.7143C26.9776 18.7283 28 19.5813 28 20.6322V24.0961C28 25.147 26.9776 26 25.7143 26H21.5591C20.2958 26 19.2734 25.147 19.2734 24.0961V21.2986C19.2734 20.8175 19.0427 20.3543 18.6342 20.0141C17.782 19.3033 16.4003 19.3033 15.548 20.0141L9.03399 25.4415C8.60535 25.7995 8.0229 26 7.41777 26H6.28565C5.02369 26 4 25.147 4 24.0948V23.153C4 22.6478 4.24079 22.163 4.66943 21.805L11.1847 16.3763C12.0357 15.6668 12.0357 14.5156 11.1847 13.8048C10.775 13.4646 10.2203 13.273 9.64164 13.273H6.28565C5.02369 13.273 4 12.42 4 11.3678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRariWhite);
export default __webpack_public_path__ + "static/media/rari-white.bc05745aabd3688593f5b4976bf4671e.svg";
export { ForwardRef as ReactComponent };